<div class="numero_piezas">{{ numeroPedidosRechazados }}</div>
<div class="descripcion">Trabajos rechazados</div>
